import { useMemo } from 'react';
import { OrganizationMembershipResponse } from '@/shared/api';

const DEFAULT_MEMBER_ROUTE = '/organization-procs';
const DEFAULT_ADMIN_ROUTE = '/dashbard';
const DEFAULT_ROUTE_ROLES: Array<OrganizationMembershipResponse['role']> = [
  'admin',
  'member',
];

export const useRolesAccessVerification = (
  activeOrganization?: Partial<OrganizationMembershipResponse>,
  allowedRoles = DEFAULT_ROUTE_ROLES,
) =>
  useMemo(() => {
    const hasRoleAccess =
      activeOrganization?.role &&
      allowedRoles.includes(activeOrganization.role);

    const roleErrorRedirectPath = !allowedRoles.includes('member')
      ? DEFAULT_MEMBER_ROUTE
      : DEFAULT_ADMIN_ROUTE;

    return { hasRoleAccess, roleErrorRedirectPath };
  }, [activeOrganization?.role, allowedRoles]);
